import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-dropdown-questiontype',
  templateUrl: './dropdown.questiontype.component.html'
})
export class DropdownQuestiontypeComponent implements OnInit, OnDestroy {
  @Input() required:boolean;
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() questioninitmixin:any;
  @Input() disabled:boolean;
  value:'';
  items:Array<string>;
  formSegment:FormGroup;

  constructor(){
    this.items=[];
  }

  public getValue():object {
    var result={};
    if(!this.disabled) {
      result[this.questionid]=this.formSegment.value['item'];
    } else {
      result[this.questionid]=null;
    }
    return result;
  }

  isValid():boolean {
    if(this.disabled) {
      return true;
    }
    var val = this.formSegment.value['item'];
    var maybe = !this.formSegment.controls['item'].errors;
    if(maybe) {
      if(this.required && ((val==='') || (val===null))) {
        maybe=false;
      }
    }

    return maybe;
  }
  validate():boolean {
    this.formSegment.controls['item'].markAsTouched();
    return this.isValid();
  }

  get formError():string {
    if((this.formSegment.controls['item'].dirty || this.formSegment.controls['item'].touched)) {
      if(!!this.formSegment.controls['item'].errors) {
        return 'This answer is required.';
      }
    }
  }

  ngOnInit() {
    var init={};
    var validators=[];
    if (this.required) {
      validators.push(Validators.required);
    }
    if(!!this.value) {
      init['item']=new FormControl(this.value,validators);
    } else {
      init['item']=new FormControl(undefined,validators);
    }
    if(!!this.questioninitmixin && !!this.questioninitmixin.items) {
      this.items=this.questioninitmixin.items;
    }

    this.formSegment=new FormGroup(init);
  }

  ngOnDestroy() {
  }
}




// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/dropdown.questiontype.component.ts